import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconComponent } from '@iss/core/icon';

@Component({
  selector: 'wo-confirmation-overlay',
  standalone: true,
  styleUrls: [ './confirmation-overlay.component.scss' ],
  templateUrl: './confirmation-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
  ],
})
export class ConfirmationOverlayComponent {
  @Input({ required: true }) public title!: string;
}
